import React, { useMemo } from 'react';

import { useAppDispatch, useAppSelector } from 'utils/hooks';

import activeEditor from 'domains/active_editor';
import canvases from 'domains/canvases';
import ui from 'domains/ui';
import crops from 'domains/crops';

import Button from 'components/shared/Button';
import ImageTools from './ImageTools';
import MaskTools from './MaskTools';

function Toolbar() {
  const dispatch = useAppDispatch();
  const activeCanvasId = useAppSelector(activeEditor.selectors.canvasId);
  const shouldRotateVisualOnly = useAppSelector(activeEditor.selectors.hasRotatedNodes);
  const canRotateCanvas = useAppSelector(activeEditor.selectors.canRotate);
  const hasBorderColor = useAppSelector(activeEditor.selectors.hasBorderColor);
  const nodeHasImage = useAppSelector(crops.selectors.activeNodePhotoLoaded);

  const canvasRotationAllowed = useMemo(
    () => shouldRotateVisualOnly || canRotateCanvas,
    [shouldRotateVisualOnly, canRotateCanvas]
  );

  function handleRotateCanvas() {
    if (shouldRotateVisualOnly) {
      dispatch(ui.actions.rotateVisualOnly());
    } else if (activeCanvasId) {
      dispatch(canvases.actions.rotateCanvas(activeCanvasId));
    }
  }

  function handleZoom(zoom: string) {
    if (activeCanvasId) {
      dispatch(crops.actions.zoomCrop({ canvasId: activeCanvasId, zoom: parseFloat(zoom) }));
    }
  }

  function handleRotateImage() {
    dispatch(crops.actions.rotateActiveImage());
  }

  function handleShowImageFilters() {
    dispatch(ui.actions.setActiveContentSidebarMenu('image-filters'));
  }

  return (
    <div className="toolbar">
      <div className="edit-tools">
        {canvasRotationAllowed && (
          <Button
            type="icon"
            appearance="themed"
            a11yText="Rotate Canvas"
            icon="retweet"
            onClick={handleRotateCanvas}
            size="lg"
          />
        )}
        {nodeHasImage && (
          <ImageTools
            handleZoom={handleZoom}
            handleRotateImage={handleRotateImage}
            handleShowImageFilters={handleShowImageFilters}
          />
        )}
        {hasBorderColor && <MaskTools />}
      </div>
    </div>
  );
}

export default Toolbar;
